import {
  GENAI_CREATE_SESSION_SUCCESS,
  GENAI_STREAM_APPEND,
  GENAI_CLEAR_MESSAGES,
  GENAI_LOADING,
  EMAIL_TEMPLATES,
  GENAI_CHAT_CONVERSATION,
} from "../actionType/genAIType";

const initialState = {
  sessionId: null,
  streamMessages: "",
  createdSessionReply: "",
  loading: false,
  emailTemplates: [],
  chatConversation: [],
};

export const allowedStages = [
  "FALLBACK",
  "STREAMING",
  "ERROR",
  "INPUT_REQUIRED",
  "SUCCESS",
];

function mergeStreamingMessages(state, action) {
  const newMessage = action.payload;

  let filtered = (state.chatConversation || [])
    .filter(
      (d) =>
        (d?.from === "bot" && allowedStages.includes(d?.stage)) ||
        d?.from === "user",
    )
    .filter((d) => d?.text);

  const last = filtered[filtered.length - 1];
  if (
    last &&
    last.from === "bot" &&
    newMessage.from === "bot" &&
    last.stage === "STREAMING" &&
    newMessage.stage === "STREAMING"
  ) {
    return [
      ...filtered.slice(0, -1),
      {
        ...last,
        id: newMessage.id,
        text: last.text + newMessage.text,
      },
    ];
  }

  return [...filtered, newMessage];
}

export const genAIReducer = (state = initialState, action) => {
  switch (action.type) {
    case GENAI_CREATE_SESSION_SUCCESS:
      return {
        ...state,
        sessionId: action.payload.sessionId,
        createdSessionReply: action.payload.reply || "",
      };

    case GENAI_STREAM_APPEND:
      return {
        ...state,
        streamMessages: state.streamMessages + action.payload,
      };

    case GENAI_CLEAR_MESSAGES:
      return {
        ...state,
        streamMessages: "",
      };

    case GENAI_CHAT_CONVERSATION:
      return {
        ...state,
        chatConversation:
          action?.payload === null ? [] : mergeStreamingMessages(state, action),
      };

    case GENAI_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case EMAIL_TEMPLATES:
      return { ...state, emailTemplates: action.payload };

    default:
      return state;
  }
};
